import { toUpper } from 'lodash';

// local dependencies
import { WIDGET_NAMES } from 'constants/entity-names';

// import views (components)
import { AuthFlowCallerIdentificationMemberWidget } from 'ui/containers/AuthFlowCallerIdentificationMemberWidget';
import { AuthFlowCallerIdentificationPharmacyWidget } from 'ui/containers/AuthFlowCallerIdentificationPharmacyWidget';
import { AuthFlowCallerIdentificationClientWidget } from 'ui/containers/AuthFlowCallerIdentificationClientWidget';
import { AuthFlowCallerIdentificationDoctor } from 'ui/containers/AuthFlowCallerIdentificationDoctor';
import { AuthFlowCallerIdentificationOthers } from 'ui/containers/AuthFlowCallerIdentificationOthers';
import { AuthFlowCallerIdentificationThirdParty } from 'ui/containers/AuthFlowCallerIdentificationThirdParty';
import { MemberDetailsClaimsEntityWidget } from 'ui/containers/MemberDetailsClaimsEntityWidget';
import { MemberDetailsPrescriptionsEntityWidget } from 'ui/containers/MemberDetailsPrescriptionsEntityWidget';
import { MemberDetailsOrdersEntityWidget } from 'ui/containers/MemberDetailsOrdersEntityWidget';
import { MemberDetailsArEntityWidget } from 'ui/containers/MemberDetailsAREntityWidget';
import { MemberDetailsPriorAuthorizationsEntityWidget } from 'ui/containers/MemberDetailsPriorAuthorizationsEntityWidget';
import { MemberDetailsCommunicationHistoryContactLogWidget } from 'ui/containers/MemberDetailsCommunicationHistoryContactLogWidget';
import { MemberDetailsCommunicationHistoryCallLogWidget } from 'ui/containers/MemberDetailsCommunicationHistoryCallLogWidget';
import { MemberInfoCommunicationSettings } from 'ui/containers/MemberInfoCommunicationSettings';
import { MemberSecuritySettingsInfo } from 'ui/containers/MemberSecuritySettingsInfo';
import { MemberAllergiesInfo } from 'ui/containers/MemberAllergiesInfo';
import { MemberHealthConditions } from 'ui/containers/MemberHealthConditions';
import { MemberInfoSettingShippingInfo } from 'ui/containers/MemberInfoSettingShippingInfo';
import { CallItemDetailInnerWidget } from 'ui/containers/CallItemDetailInnerWidget';
import { ActionItemDetailInnerWidget } from 'ui/containers/ActionItemDetailInnerWidget';
import { MemberInfoSettingPaymentInfo } from 'ui/containers/MemberInfoSettingPaymentInfo';
import { MemberDetailsSavingsMailPrescriptionWidget } from 'ui/containers/MemberDetailsSavingsMailPrescriptionWidget';
import { MemberDetailsSavingsRetailPrescriptionWidget } from 'ui/containers/MemberDetailsSavingsRetailPrescriptionWidget';
import { CsrOrderListNotesLineItem } from 'ui/containers/CSROrderListNotesLineItem';
import { CsrOrderListNotesWorkFlowItem } from 'ui/containers/CSROrderListNotesWorkFlowItem';
import { CsrOrderListNotesWorkFlowLog } from 'ui/containers/CSROrderListNotesWorkFlowLog';
import { MemberDetailsCommunicationHistoryActionLogWidget } from 'ui/containers/MemberDetailsCommunicationHistoryActionLogWidget';
import { MemberDetailsCommunicationHistoryToDosWidget } from 'ui/containers/MemberDetailsCommunicationHistoryToDosWidget';
import { StatisticsReports } from 'ui/containers/StatisticsReports';
import { WellViewAdministration } from 'ui/containers/WellViewAdministration';
import { TrendsReports } from 'ui/containers/TrendsReports';
import { MemberInfoCommunicationSettingsPhone } from 'ui/containers/MemberInfoCommunicationSettingsPhone';
import { MemberInfoCommunicationSettingsEmail } from 'ui/containers/MemberInfoCommunicationSettingsEmail';
import { MemberInfoCommunicationSettingsWellConnect } from 'ui/containers/MemberInfoCommunicationSettingsWellConnect';
import { CallCategoriesAndReasons } from 'ui/containers/CallCategoriesAndReasons';

/*-------------*/

// default tab view
const defaultTabView = ( props ) => toUpper( props.__text__ );

// set display name
defaultTabView.displayName = 'widgetsTabFlowResolver.defaultTabView';

// set default props
defaultTabView.defaultProps = {
    __text__: 'DEFAULT_TAB_VIEW', // special prop
};

/*-------------*/

/**
 * @type {function}
 * @desc Resolvers are pure functions used for resolving templates (React components) or to transform some data.
 * A resolver function takes an `id` and an optional `payload` and returns a `result`.
 * Based on `switch` cases inside this function, correct `result` should be returned.
 * @param {object} payload
 * @example
 * import { getTabView } from 'resolvers/widgetsTabFlow';
 */
export const getTabView = ( name ) => {
    switch ( name ) {


        // call authorization: caller verification views
        case WIDGET_NAMES.AUTH_FLOW_CALLER_IDENTIFICATION_MEMBER: {
            return AuthFlowCallerIdentificationMemberWidget;
        }

        // call authorization: pharmacy caller verification views
        case WIDGET_NAMES.AUTH_FLOW_CALLER_IDENTIFICATION_PHARMACY: {
            return AuthFlowCallerIdentificationPharmacyWidget;
        }

        // call authorization: client caller verification views
        case WIDGET_NAMES.AUTH_FLOW_CALLER_IDENTIFICATION_CLIENT: {
            return AuthFlowCallerIdentificationClientWidget;
        }

        // call authorization: doctor caller verification views
        case WIDGET_NAMES.AUTH_FLOW_CALLER_IDENTIFICATION_DOCTOR: {
            return AuthFlowCallerIdentificationDoctor;
        }

        // call authorization: others caller verification views
        case WIDGET_NAMES.AUTH_FLOW_CALLER_IDENTIFICATION_OTHERS: {
            return AuthFlowCallerIdentificationOthers;
        }

        // call authorization: third party caller verification views
        case WIDGET_NAMES.AUTH_FLOW_CALLER_IDENTIFICATION_THIRD_PARTY: {
            return AuthFlowCallerIdentificationThirdParty;
        }

        // member details entities claims views
        case WIDGET_NAMES.MEMBER_DETAILS_ENTITIES_CLAIMS: {
            return MemberDetailsClaimsEntityWidget;
        }

        // member Info Settings
        case WIDGET_NAMES.MEMBER_INFO_SETTINGS_COMMUNICATION_SETTINGS: {
            return MemberInfoCommunicationSettings;
        }

        // member details entities claims views
        case WIDGET_NAMES.MEMBER_DETAILS_ENTITIES_PRESCRIPTION: {
            return MemberDetailsPrescriptionsEntityWidget;
        }

        // member details entities claims views
        case WIDGET_NAMES.MEMBER_DETAILS_ENTITIES_ORDERS: {
            return MemberDetailsOrdersEntityWidget;
        }

        case WIDGET_NAMES.MEMBER_DETAILS_ENTITIES_PRIOR_AUTHORIZATION: {
            return MemberDetailsPriorAuthorizationsEntityWidget;
        }

        // member detais entities AR views
        case WIDGET_NAMES.MEMBER_DETAILS_ENTITIES_AR: {
            return MemberDetailsArEntityWidget;
        }

        // member details communication history contact log views
        case WIDGET_NAMES.MEMBER_DETAILS_COMMUNICATION_HISTORY_CONTACT_LOG: {
            return MemberDetailsCommunicationHistoryContactLogWidget;
        }

        // member details communication history call log views
        case WIDGET_NAMES.MEMBER_DETAILS_COMMUNICATION_HISTORY_CALL_LOG: {
            return MemberDetailsCommunicationHistoryCallLogWidget;
        }

        // member details communication history action log views
        case WIDGET_NAMES.MEMBER_DETAILS_COMMUNICATION_HISTORY_ACTION_LOG: {
            return MemberDetailsCommunicationHistoryActionLogWidget;
        }

        // member Info Security Settings
        case WIDGET_NAMES.MEMBER_INFO_SECURITY_INFO_SETTINGS: {
            return MemberSecuritySettingsInfo;
        }

        // member Info payment Settings
        case WIDGET_NAMES.MEMBER_INFO_SETTINGS_PAYMENT_INFO: {
            return MemberInfoSettingPaymentInfo;
        }

        // member Allergies Info
        case WIDGET_NAMES.MEMBER_ALLERGIES_INFO: {
            return MemberAllergiesInfo;
        }

        // member Allergies Info
        case WIDGET_NAMES.MEMBER_HEALTH_CONDITIONS: {
            return MemberHealthConditions;
        }

        // member Info Security Settings
        case WIDGET_NAMES.MEMBER_INFO_SETTINGS_SHIPING_INFO: {
            return MemberInfoCommunicationSettings;
        }

        // Call detail tabs inner widgets
        case WIDGET_NAMES.CALL_DETAIL_TABS_INNER_WIDGET: {
            return CallItemDetailInnerWidget;
        }

        // member details mail prescriptions
        case WIDGET_NAMES.MEMBER_DETAILS_SAVINGS_MAIL_PRESCRIPTION: {
            return MemberDetailsSavingsMailPrescriptionWidget;
        }

        // member details retail prescriptions
        case WIDGET_NAMES.MEMBER_DETAILS_SAVINGS_RETAIL_PRESCRIPTION: {
            return MemberDetailsSavingsRetailPrescriptionWidget;
        }

        // action detail tabs inner widgets
        case WIDGET_NAMES.ACTION_DETAIL_TABS_INNER_WIDGET: {
            return ActionItemDetailInnerWidget;
        }

        case WIDGET_NAMES.CSR_ORDER_NOTES_LINE: {
            return CsrOrderListNotesLineItem;
        }

        case WIDGET_NAMES.CSR_ORDER_NOTES_LOG: {
            return CsrOrderListNotesWorkFlowLog;
        }

        case WIDGET_NAMES.CSR_ORDER_NOTES_ITEM: {
            return CsrOrderListNotesWorkFlowItem;
        }

        // Statistics Reports on the Reports Tab
        case WIDGET_NAMES.REPORTS_STATISTICS: {
            return StatisticsReports;
        }

        // well view administration tab
        case WIDGET_NAMES.WELL_VIEW_ADMINISTRATION: {
            return WellViewAdministration;
        }

        // Well serve administration tab
        case WIDGET_NAMES.WELL_SERVE_ADMINISTRATION: {
            return CallCategoriesAndReasons;
        }

        case WIDGET_NAMES.REPORTS_TRENDS: {
            return TrendsReports;
        }
        
        // member details communication history to-dos
        case WIDGET_NAMES.MEMBER_DETAILS_COMMUNICATION_HISTORY_TO_DOS: {
            return MemberDetailsCommunicationHistoryToDosWidget;
        }

        case WIDGET_NAMES.MEMBER_INFO_SETTINGS_COMMUNICATION_SETTINGS_PHONE: {
            return MemberInfoCommunicationSettingsPhone;
        }

        case WIDGET_NAMES.MEMBER_INFO_SETTINGS_COMMUNICATION_SETTINGS_EMAIL: {
            return MemberInfoCommunicationSettingsEmail;
        }

        case WIDGET_NAMES.MEMBER_INFO_SETTINGS_COMMUNICATION_SETTINGS_WELLCONNECT: {
            return MemberInfoCommunicationSettingsWellConnect;
        }

        case WIDGET_NAMES.MEMBER_INFO_SETTINGS_SHIPPING_ADDRESS:
        case WIDGET_NAMES.MEMBER_INFO_SETTINGS_BILLING_ADDRESS: {
            return MemberInfoSettingShippingInfo;
        }
        
        /*-----------*/

        // return default view
        default: {
            return defaultTabView;
        }
    }
};
